export { default } from "./useConfigMutation";
